import { getCookie } from './browserHelpers';

const cookieResult = getCookie('auth_consumer_id');
let consumerIdLet = 'Website_User';
if (cookieResult !== null) {
  consumerIdLet = cookieResult;
}

const consumerId = consumerIdLet;

export default consumerId;
